import api from '@edu-fe/api'

const module = {
  name: 'authentication',
  checkId (id) {
    return api.create('/my/verify/identity/code', {
      method: 'post',
      data: {
        identityCode: id
      },
      formData: true
    })
  },
  submit (data) {
    return api.create('/my/identity', {
      method: 'post',
      data: data,
      formData: false
    })
  },
  uploadBack (data) {
    console.log(data)
    return api.create('/my/identity/upload', {
      method: 'post',
      // baseURL: 'http://192.168.37.10/API_V2',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  upload (url, file, size) {
    return api.create('', {
      method: 'PUT',
      baseURL: url,
      data: file,
      headers: {
        'Date': new Date(),
        'x-kss-acl': 'private',
        'Content-Type': 'multipart/form-data',
        'Host': 'ks3-cn-beijing.ksyun.com',
        'Content-Length': size
      },
      formData: true
    })
  },
  getUrl (name) {
    return api.create(`/my/ks3/upload/url?fileName=front_${encodeURIComponent(name)}.png&contentType=multipart/form-data`)
  },

  // 发送手机验证码
  sendCode: api.create('/my/verify/phone/code'),

  // 提交
  verify: api.create('/my/promote/identity/upload', {
    method: 'post'
  })
}

export default module
